(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var body = document.body;
  var activeDrawer = null;
  var activeTrigger = null;

  function syncHeaderGradientPhase() {
    var header = document.querySelector('[data-site-header], .site-header');
    if (!header || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var styles = window.getComputedStyle(header);
    if (!styles.animationName || styles.animationName === 'none') return;
    var durationSeconds = parseFloat(styles.animationDuration);
    if (!durationSeconds || durationSeconds <= 0) return;
    var fullCycleSeconds = durationSeconds * 2;
    var phaseSeconds = (Date.now() / 1000) % fullCycleSeconds;
    header.style.animationDelay = '-' + phaseSeconds.toFixed(3) + 's';
  }

  syncHeaderGradientPhase();

  function warmDeferredHomepageContent() {
    var isAggressivePreloadPage = body.classList.contains('template-index') ||
      body.classList.contains('template-collection');
    var deferredSections = Array.prototype.slice.call(document.querySelectorAll(
      '.testimonial, .home-products, .editorial-pair, .home-news'
    ));
    var deferredImages = isAggressivePreloadPage
      ? Array.prototype.slice.call(document.querySelectorAll('img[loading="lazy"]'))
      : [];
    var preloadDistance = window.matchMedia('(max-width: 767px)').matches
      ? '3600px 0px'
      : '2200px 0px';

    function renderSection(section) {
      section.classList.add('is-prewarmed');
    }

    function loadAndDecodeImage(image) {
      if (image.dataset.prewarmed === 'true') return;
      image.dataset.prewarmed = 'true';
      image.loading = 'eager';
      if (image.decode) image.decode().catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      deferredSections.forEach(renderSection);
      deferredImages.forEach(loadAndDecodeImage);
      return;
    }

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        renderSection(entry.target);
        sectionObserver.unobserve(entry.target);
      });
    }, { rootMargin: preloadDistance });

    var imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        loadAndDecodeImage(entry.target);
        imageObserver.unobserve(entry.target);
      });
    }, { rootMargin: preloadDistance });

    deferredSections.forEach(function (section) { sectionObserver.observe(section); });
    deferredImages.forEach(function (image) { imageObserver.observe(image); });
  }

  warmDeferredHomepageContent();

  function getBackdrop() {
    return document.querySelector('[data-drawer-backdrop]');
  }

  function setExpanded(trigger, expanded) {
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function openDrawer(id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    closeDrawer(false);
    activeDrawer = drawer;
    activeTrigger = trigger || null;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setExpanded(activeTrigger, true);
    var backdrop = getBackdrop();
    if (backdrop) backdrop.hidden = false;
    body.classList.add('drawer-open');
    var closeButton = drawer.querySelector('[data-drawer-close]');
    if (closeButton) closeButton.focus();
  }

  function closeDrawer(restoreFocus) {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('is-open');
    activeDrawer.setAttribute('aria-hidden', 'true');
    setExpanded(activeTrigger, false);
    var backdrop = getBackdrop();
    if (backdrop) backdrop.hidden = true;
    body.classList.remove('drawer-open');
    if (restoreFocus !== false && activeTrigger) activeTrigger.focus();
    activeDrawer = null;
    activeTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-drawer-open]');
    if (openButton) {
      openDrawer(openButton.getAttribute('data-drawer-open'), openButton);
      return;
    }

    if (event.target.closest('[data-drawer-close]') || event.target.closest('[data-drawer-backdrop]')) {
      closeDrawer(true);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer(true);
  });

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function shopRoute(path) {
    return shopRoot() + String(path || '').replace(/^\//, '');
  }

  function formatCartMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function appendFreeShippingProgress(container, drawer, cart) {
    if (drawer.dataset.freeShippingEnabled !== 'true') return;

    var threshold = parseInt(drawer.dataset.freeShippingThresholdCents, 10);
    if (!Number.isFinite(threshold) || threshold <= 0) return;

    var total = Math.max(0, Number(cart.total_price) || 0);
    var remaining = Math.max(0, threshold - total);
    var progress = Math.min(100, Math.max(0, total / threshold * 100));
    var awayTemplate = drawer.dataset.freeShippingAwayTemplate || "You're [amount] away from free U.S. shipping";
    var unlockedTemplate = drawer.dataset.freeShippingUnlockedTemplate || 'Free U.S. shipping unlocked';

    var incentive = document.createElement('div');
    incentive.className = 'drawer-cart__shipping';
    incentive.setAttribute('data-free-shipping-progress', '');

    var copy = document.createElement('div');
    copy.className = 'drawer-cart__shipping-copy';
    var icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✦';
    var message = document.createElement('strong');
    message.setAttribute('data-free-shipping-message', '');
    message.textContent = remaining > 0
      ? awayTemplate.replace('[amount]', formatCartMoney(remaining))
      : unlockedTemplate;
    copy.appendChild(icon);
    copy.appendChild(message);
    incentive.appendChild(copy);

    var track = document.createElement('div');
    track.className = 'drawer-cart__shipping-track';
    track.setAttribute('role', 'progressbar');
    track.setAttribute('aria-label', 'Progress toward free shipping');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', String(threshold));
    track.setAttribute('aria-valuenow', String(Math.min(total, threshold)));
    var fill = document.createElement('span');
    fill.style.width = progress.toFixed(2) + '%';
    track.appendChild(fill);
    incentive.appendChild(track);
    container.appendChild(incentive);
  }

  function appendCartActions(container, drawer) {
    var actions = document.createElement('div');
    actions.className = 'drawer-cart__actions';

    var cartLink = document.createElement('a');
    cartLink.className = 'borders-button';
    cartLink.href = shopRoute('cart');
    cartLink.textContent = drawer.dataset.cartViewLabel || 'View cart';
    actions.appendChild(cartLink);

    var checkoutForm = document.createElement('form');
    checkoutForm.action = shopRoute('cart');
    checkoutForm.method = 'post';
    var checkoutButton = document.createElement('button');
    checkoutButton.className = 'borders-button borders-button--solid';
    checkoutButton.type = 'submit';
    checkoutButton.name = 'checkout';
    checkoutButton.textContent = drawer.dataset.cartCheckoutLabel || 'Checkout';
    checkoutForm.appendChild(checkoutButton);
    actions.appendChild(checkoutForm);
    container.appendChild(actions);
  }

  function appendCartItemControls(details, drawer, item) {
    var controls = document.createElement('div');
    controls.className = 'drawer-cart__controls';

    var quantity = document.createElement('div');
    quantity.className = 'drawer-cart__quantity';
    quantity.setAttribute('role', 'group');
    quantity.setAttribute(
      'aria-label',
      (drawer.dataset.cartQuantityLabel || 'Quantity') + ' — ' + (item.product_title || '')
    );

    var decrease = document.createElement('button');
    decrease.type = 'button';
    decrease.className = 'drawer-cart__quantity-button';
    decrease.setAttribute('data-cart-line-action', 'change');
    decrease.setAttribute('data-cart-key', item.key);
    decrease.setAttribute('data-cart-quantity', String(Math.max(0, item.quantity - 1)));
    decrease.setAttribute(
      'aria-label',
      (drawer.dataset.cartDecreaseLabel || 'Decrease quantity') + ' — ' + (item.product_title || '')
    );
    decrease.textContent = '−';

    var value = document.createElement('span');
    value.className = 'drawer-cart__quantity-value';
    value.setAttribute('aria-live', 'polite');
    value.textContent = item.quantity;

    var increase = document.createElement('button');
    increase.type = 'button';
    increase.className = 'drawer-cart__quantity-button';
    increase.setAttribute('data-cart-line-action', 'change');
    increase.setAttribute('data-cart-key', item.key);
    increase.setAttribute('data-cart-quantity', String(item.quantity + 1));
    increase.setAttribute(
      'aria-label',
      (drawer.dataset.cartIncreaseLabel || 'Increase quantity') + ' — ' + (item.product_title || '')
    );
    increase.textContent = '+';

    quantity.appendChild(decrease);
    quantity.appendChild(value);
    quantity.appendChild(increase);
    controls.appendChild(quantity);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'drawer-cart__remove';
    remove.setAttribute('data-cart-line-action', 'remove');
    remove.setAttribute('data-cart-key', item.key);
    remove.setAttribute('data-cart-quantity', '0');
    remove.textContent = drawer.dataset.cartRemoveLabel || 'Remove';
    controls.appendChild(remove);
    details.appendChild(controls);
  }

  function setCartDrawerBusy(drawer, busy) {
    if (!drawer) return;
    drawer.classList.toggle('is-updating', busy);
    drawer.setAttribute('aria-busy', busy ? 'true' : 'false');
    drawer.querySelectorAll('[data-cart-line-action]').forEach(function (button) {
      button.disabled = busy;
    });
  }

  function showCartDrawerFeedback(drawer, message) {
    if (!drawer) return;
    var feedback = drawer.querySelector('[data-cart-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.hidden = !message;
  }

  function fetchCartState() {
    return fetch(shopRoute('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh the cart.');
      return response.json();
    });
  }

  function renderCartDrawer(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !cart) return;

    var heading = drawer.querySelector('.drawer__header strong');
    if (heading) heading.textContent = (drawer.dataset.cartTitle || 'Cart') + ' (' + cart.item_count + ')';

    document.querySelectorAll('.header-action__count').forEach(function (count) {
      count.textContent = cart.item_count;
    });

    var container = drawer.querySelector('.drawer-cart');
    if (!container) return;
    container.textContent = '';

    var feedback = document.createElement('p');
    feedback.className = 'drawer-cart__feedback';
    feedback.setAttribute('data-cart-feedback', '');
    feedback.setAttribute('role', 'status');
    feedback.hidden = true;
    container.appendChild(feedback);

    if (!cart.item_count) {
      var emptyText = document.createElement('p');
      emptyText.textContent = drawer.dataset.cartEmptyText || 'Your cart is currently empty.';
      container.appendChild(emptyText);
      var continueButton = document.createElement('button');
      continueButton.type = 'button';
      continueButton.className = 'borders-button';
      continueButton.setAttribute('data-drawer-close', '');
      continueButton.textContent = drawer.dataset.cartContinueLabel || 'Continue shopping';
      container.appendChild(continueButton);
      return;
    }

    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'drawer-cart__item';

      if (item.image) {
        var imageLink = document.createElement('a');
        imageLink.href = item.url;
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title || '';
        image.width = 90;
        image.height = 90;
        image.loading = 'lazy';
        imageLink.appendChild(image);
        row.appendChild(imageLink);
      }

      var details = document.createElement('div');
      details.className = 'drawer-cart__details';
      var title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.product_title;
      details.appendChild(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('span');
        variant.className = 'drawer-cart__variant';
        variant.textContent = item.variant_title;
        details.appendChild(variant);
      }
      var price = document.createElement('span');
      price.className = 'drawer-cart__line-price';
      price.textContent = item.quantity + ' × ' + formatCartMoney(item.final_price);
      details.appendChild(price);
      appendCartItemControls(details, drawer, item);
      row.appendChild(details);
      container.appendChild(row);
    });

    appendFreeShippingProgress(container, drawer, cart);

    var total = document.createElement('div');
    total.className = 'drawer-cart__total';
    var totalLabel = document.createElement('span');
    totalLabel.textContent = drawer.dataset.cartTotalLabel || 'Total';
    var totalPrice = document.createElement('strong');
    totalPrice.textContent = formatCartMoney(cart.total_price);
    total.appendChild(totalLabel);
    total.appendChild(totalPrice);
    container.appendChild(total);
    appendCartActions(container, drawer);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-line-action]');
    if (!button) return;

    event.preventDefault();
    var drawer = button.closest('[data-cart-drawer]');
    var key = button.getAttribute('data-cart-key');
    var quantity = parseInt(button.getAttribute('data-cart-quantity'), 10);
    if (!drawer || !key || !Number.isFinite(quantity) || quantity < 0) return;

    setCartDrawerBusy(drawer, true);
    showCartDrawerFeedback(drawer, '');

    fetch(shopRoute('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'Unable to update this item.');
          return data;
        });
      })
      .then(function (updatedCart) {
        return fetchCartState().catch(function () {
          return updatedCart;
        });
      })
      .then(function (cart) {
        renderCartDrawer(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (error) {
        showCartDrawerFeedback(drawer, error.message || 'Unable to update this item.');
      })
      .finally(function () {
        setCartDrawerBusy(drawer, false);
      });
  });

  async function refreshCartDrawer() {
    var cart = await fetchCartState();
    var sectionUpdated = false;

    try {
      var sectionResponse = await fetch(shopRoot() + '?sections=header', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (sectionResponse.ok) {
        var sections = await sectionResponse.json();
        var headerMarkup = sections && sections.header;
        var currentHeaderSection = document.getElementById('shopify-section-header');
        if (headerMarkup && currentHeaderSection) {
          var parsed = new DOMParser().parseFromString(headerMarkup, 'text/html');
          var replacement = parsed.getElementById('shopify-section-header');
          if (replacement) {
            currentHeaderSection.replaceWith(replacement);
          } else {
            currentHeaderSection.innerHTML = headerMarkup;
          }
          sectionUpdated = true;
          syncHeaderGradientPhase();
        }
      }
    } catch (error) {}

    if (!sectionUpdated) renderCartDrawer(cart);
    return cart;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax-cart')) return;
    if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;

    event.preventDefault();
    if (form.dataset.cartSubmitting === 'true') return;
    form.dataset.cartSubmitting = 'true';

    var submitButton = event.submitter || form.querySelector('[type="submit"]');
    var originalButtonMarkup = submitButton ? submitButton.innerHTML : '';
    var message = form.querySelector('[data-product-form-message]');
    if (message) {
      message.hidden = true;
      message.textContent = '';
      message.classList.remove('is-error');
    }
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.textContent = 'Adding…';
    }

    fetch(shopRoute('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'Unable to add this item to the cart.');
          return data;
        });
      })
      .then(function () { return refreshCartDrawer(); })
      .then(function (cart) {
        var cartTrigger = document.querySelector('[data-drawer-open="CartDrawer"]');
        openDrawer('CartDrawer', cartTrigger);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (error) {
        if (message) {
          message.textContent = error.message;
          message.classList.add('is-error');
          message.hidden = false;
        }
      })
      .finally(function () {
        form.dataset.cartSubmitting = 'false';
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          submitButton.innerHTML = originalButtonMarkup;
        }
      });
  });

  if (!window.customElements.get('vertical-slider')) {
    window.customElements.define('vertical-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.cardStackReady) return;
        this.cardStackReady = true;
        this.collectSlides();
        if (this.hasAttribute('data-design-mode')) {
          this.slides.forEach(function (item) {
            this.renderStarfield(item);
          }, this);
          this.classList.add('is-active');
          return;
        }
        this.zoom = this.hasAttribute('data-zoom');
        this.mobileZoom = this.hasAttribute('data-mobile-zoom');
        this.mobileViewport = window.matchMedia('(max-width: 767px)');
        this.parallax = this.hasAttribute('data-prlx');
        this.isNearViewport = true;
        this.needsMeasure = true;
        this.frameRequest = 0;
        this.currentScrollY = window.scrollY;
        this.targetScrollY = this.currentScrollY;
        this.lastFrameTime = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.header = document.querySelector('[data-site-header], .site-header');
        this.animateFrame = this.animateSlides.bind(this);
        this.onViewportChange = function () {
          this.targetScrollY = window.scrollY;
          this.requestAnimation();
        }.bind(this);
        this.onViewportResize = this.requestMeasure.bind(this);
        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        window.addEventListener('resize', this.onViewportResize, { passive: true });

        if ('IntersectionObserver' in window) {
          this.viewportObserver = new IntersectionObserver(function (entries) {
            this.isNearViewport = entries[0].isIntersecting;
            this.classList.toggle('is-active', this.isNearViewport);
            if (this.isNearViewport) {
              this.requestMeasure();
            } else {
              this.setStarfieldsActive(false);
            }
          }.bind(this), { rootMargin: '120% 0px 120% 0px' });
          this.viewportObserver.observe(this);
        } else {
          this.classList.add('is-active');
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onViewportResize);
          this.resizeObserver.observe(this);
          if (this.slides[0] && this.slides[0].card) this.resizeObserver.observe(this.slides[0].card);
        }

        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onViewportResize);
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            if (this.isConnected) this.requestMeasure();
          }.bind(this));
        }

        this.requestAnimation();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onViewportChange);
        window.removeEventListener('resize', this.onViewportResize);
        if (this.viewportObserver) this.viewportObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.reducedMotion && this.reducedMotion.removeEventListener) {
          this.reducedMotion.removeEventListener('change', this.onViewportResize);
        }
        if (this.frameRequest) window.cancelAnimationFrame(this.frameRequest);
        this.setStarfieldsActive(false);
      }

      collectSlides() {
        this.slides = Array.prototype.map.call(this.querySelectorAll('[data-stack-slide]'), function (slide, index) {
          slide.style.setProperty('--stack-index', index + 1);
          var media = slide.querySelector('[data-stack-media]');
          var baseScale = media ? parseFloat(getComputedStyle(media).getPropertyValue('--subject-base-scale')) || 1 : 1;
          return {
            parent: slide,
            card: slide.querySelector('[data-stack-card]'),
            media: media,
            starfield: slide.querySelector('[data-starfield]'),
            starCanvas: slide.querySelector('[data-starfield-canvas]'),
            baseScale: baseScale
          };
        });
      }

      refreshBaseScales() {
        this.slides.forEach(function (item) {
          if (!item.media) return;
          item.baseScale = parseFloat(getComputedStyle(item.media).getPropertyValue('--subject-base-scale')) || 1;
        });
      }

      isZoomEnabled() {
        return this.mobileViewport.matches ? this.mobileZoom : this.zoom;
      }

      requestAnimation() {
        if (!this.isNearViewport || this.frameRequest) return;
        this.frameRequest = window.requestAnimationFrame(this.animateFrame);
      }

      requestMeasure() {
        this.refreshBaseScales();
        this.needsMeasure = true;
        this.requestAnimation();
      }

      measureSlides() {
        if (!this.slides.length || !this.slides[0].card) return;
        var gridPadding = parseFloat(getComputedStyle(this).paddingLeft) || 0;
        var headerHeight = this.header ? this.header.offsetHeight : 0;
        var firstCardHeight = this.slides[0].card.offsetHeight;
        var scrollTop = window.scrollY;
        this.metrics = {
          sliderOffset: this.getBoundingClientRect().top + window.scrollY,
          sliderHeight: Math.min(firstCardHeight, window.innerHeight + (gridPadding * 2) - headerHeight),
          viewportHeight: window.innerHeight
        };
        this.slides.forEach(function (item) {
          item.parentBottom = item.parent.getBoundingClientRect().bottom + scrollTop;
          this.renderStarfield(item);
        }, this);
        this.needsMeasure = false;
      }

      randomFromSeed(seed) {
        var value = 2166136261;
        for (var index = 0; index < seed.length; index += 1) {
          value ^= seed.charCodeAt(index);
          value = Math.imul(value, 16777619);
        }
        return function () {
          value += 0x6D2B79F5;
          var mixed = value;
          mixed = Math.imul(mixed ^ (mixed >>> 15), mixed | 1);
          mixed ^= mixed + Math.imul(mixed ^ (mixed >>> 7), mixed | 61);
          return ((mixed ^ (mixed >>> 14)) >>> 0) / 4294967296;
        };
      }

      renderStarfield(item) {
        if (!item.starfield || !item.starCanvas || !item.card) return;
        var density = Math.max(0, Math.min(1, (parseFloat(item.starfield.dataset.starDensity) || 0) / 100));
        var size = Math.max(1, parseFloat(item.starfield.dataset.starSize) || 4);
        var randomness = Math.max(0, Math.min(1, (parseFloat(item.starfield.dataset.starRandomness) || 0) / 100));
        var width = Math.round(item.starfield.clientWidth);
        var height = Math.round(item.starfield.clientHeight);
        if (!width || !height) return;

        var pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5);
        var renderKey = [width, height, pixelRatio, density, size, randomness, item.starfield.dataset.starSeed].join('|');
        if (item.starfieldRenderKey === renderKey) return;
        item.starfieldRenderKey = renderKey;

        item.starCanvas.width = Math.round(width * pixelRatio);
        item.starCanvas.height = Math.round(height * pixelRatio);
        var context = item.starCanvas.getContext('2d');
        if (!context) return;
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        context.clearRect(0, 0, width, height);

        var random = this.randomFromSeed(item.starfield.dataset.starSeed || 'tylil-starfield');
        var cellSize = Math.max(15, size * 4.5);
        var columns = Math.ceil(width / cellSize);
        var rows = Math.ceil(height / cellSize);
        context.fillStyle = '#301137';
        context.strokeStyle = '#301137';

        for (var row = 0; row < rows; row += 1) {
          for (var column = 0; column < columns; column += 1) {
            if (random() > density) continue;
            var jitter = cellSize * 0.78 * randomness;
            var x = (column + 0.5) * cellSize + ((random() - 0.5) * jitter);
            var y = (row + 0.5) * cellSize + ((random() - 0.5) * jitter);
            var diameter = size * (0.35 + (random() * 0.65 * Math.max(randomness, 0.25)));
            var radius = diameter / 2;
            var shape = random();
            context.globalAlpha = 0.35 + (random() * 0.6);

            if (shape < 0.12 && diameter > 1.5) {
              context.lineWidth = Math.max(0.55, radius * 0.3);
              context.beginPath();
              context.moveTo(x - radius, y);
              context.lineTo(x + radius, y);
              context.moveTo(x, y - radius);
              context.lineTo(x, y + radius);
              context.stroke();
            } else if (shape < 0.24 && diameter > 1.2) {
              context.beginPath();
              context.moveTo(x, y - radius);
              context.lineTo(x + radius, y);
              context.lineTo(x, y + radius);
              context.lineTo(x - radius, y);
              context.closePath();
              context.fill();
            } else {
              context.beginPath();
              context.arc(x, y, Math.max(0.4, radius), 0, Math.PI * 2);
              context.fill();
            }
          }
        }
        context.globalAlpha = 1;
      }

      setMediaTransform(item, scale, translateY) {
        if (!item.media) return;
        var motionAllowed = !this.reducedMotion.matches;
        var renderedScale = (this.isZoomEnabled() && motionAllowed ? scale : 1) * item.baseScale;
        var renderedY = this.parallax && motionAllowed ? translateY : 0;
        var transform = 'scale(' + renderedScale.toFixed(5) + ') translate3d(0,' + renderedY.toFixed(2) + 'px,0)';
        if (item.mediaTransform === transform) return;
        item.mediaTransform = transform;
        item.media.style.transform = transform;
      }

      setCardTransform(item, scale) {
        if (!item.card) return;
        var renderedScale = this.isZoomEnabled() && !this.reducedMotion.matches ? scale : 1;
        var transform = 'translateZ(0) scale(' + renderedScale.toFixed(5) + ')';
        if (item.cardTransform === transform) return;
        item.cardTransform = transform;
        item.card.style.transform = transform;
      }

      setStarfieldTransform(item, slideY, viewportHeight) {
        if (!item.starfield) return;
        var withinRange = Math.abs(slideY) < viewportHeight * 2;
        item.starfield.classList.toggle('is-active', withinRange);
        if (!withinRange) return;

        var motionAllowed = !this.reducedMotion.matches;
        var offset = motionAllowed ? Math.max(-46, Math.min(46, slideY * 0.065)) : 0;
        var x = (offset * -0.55).toFixed(2) + 'px';
        var y = offset.toFixed(2) + 'px';
        var transform = x + '|' + y;
        if (item.starfieldTransform === transform) return;
        item.starfieldTransform = transform;
        item.starfield.style.setProperty('--star-parallax-x', x);
        item.starfield.style.setProperty('--star-parallax-y', y);
      }

      setStarfieldsActive(isActive) {
        this.slides.forEach(function (item) {
          if (item.starfield) item.starfield.classList.toggle('is-active', isActive);
        });
      }

      animateSlides(timestamp) {
        this.frameRequest = 0;
        if (!this.isNearViewport || !this.slides.length || !this.slides[0].card) {
          this.setStarfieldsActive(false);
          return;
        }

        if (this.needsMeasure || !this.metrics) this.measureSlides();
        if (!this.metrics) return;

        var sliderOffset = this.metrics.sliderOffset;
        this.targetScrollY = window.scrollY;
        var scrollDelta = this.targetScrollY - this.currentScrollY;
        var motionAllowed = !this.reducedMotion.matches;

        if (!motionAllowed || Math.abs(scrollDelta) > this.metrics.viewportHeight * 1.5) {
          this.currentScrollY = this.targetScrollY;
        } else if (Math.abs(scrollDelta) > 0.1) {
          var frameDuration = this.lastFrameTime ? Math.min(64, timestamp - this.lastFrameTime) : 16.67;
          var smoothing = 1 - Math.exp(-frameDuration / 48);
          this.currentScrollY += scrollDelta * smoothing;
        } else {
          this.currentScrollY = this.targetScrollY;
        }

        this.lastFrameTime = timestamp;
        var scrollTop = this.currentScrollY;
        var sliderHeight = this.metrics.sliderHeight;
        var viewportHeight = this.metrics.viewportHeight;
        var lastIndex = this.slides.length - 1;

        this.slides.forEach(function (item, index) {
          if (!item.card) return;
          var slideY = scrollTop - sliderOffset + (viewportHeight - sliderHeight) - (sliderHeight * index);
          var coveredDistance = slideY - (viewportHeight - sliderHeight);

          if (scrollTop <= sliderOffset) {
            if (index === 0 || item.parentBottom - scrollTop <= viewportHeight) {
              this.setMediaTransform(item, 1, 0);
              this.setCardTransform(item, 1);
            } else {
              var initialMediaScale = 1 - (slideY / sliderHeight / 12);
              this.setMediaTransform(item, Math.max(1, initialMediaScale), initialMediaScale <= 1 ? 0 : slideY / 2);
              this.setCardTransform(item, 1);
            }
          } else if (slideY < 0) {
            this.setMediaTransform(item, 1 - (slideY / sliderHeight / 12), slideY / 2);
            this.setCardTransform(item, 1);
          } else if (coveredDistance <= 0) {
            this.setMediaTransform(item, 1, 0);
            this.setCardTransform(item, 1);
          } else if (index !== lastIndex) {
            this.setMediaTransform(item, 1, -coveredDistance / 4);
            this.setCardTransform(item, 1 - (coveredDistance / sliderHeight / 12));
          }

          this.setStarfieldTransform(item, slideY, viewportHeight);
        }, this);

        if (Math.abs(this.targetScrollY - this.currentScrollY) > 0.1) {
          this.requestAnimation();
        } else {
          this.lastFrameTime = 0;
        }
      }
    });
  }

  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach(function (button) {
    button.addEventListener('click', function () {
      var control = button.closest('.quantity-control');
      var input = control && control.querySelector('[data-quantity-input]');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      input.value = button.hasAttribute('data-quantity-minus') ? Math.max(1, value - 1) : value + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-page]').forEach(function (productPage) {
    var quantityInputs = Array.prototype.slice.call(productPage.querySelectorAll('[data-quantity-input]'));
    var currencyCode = productPage.getAttribute('data-currency-code') || 'USD';

    function formatProductMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currencyCode
        }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function updateSubmitTotals() {
      var quantity = Math.max(1, parseInt(quantityInputs[0] && quantityInputs[0].value, 10) || 1);
      var selectedOption = productPage.querySelector('[data-product-select] option:checked');
      var unitPrice = parseInt(
        selectedOption ? selectedOption.getAttribute('data-price-cents') : productPage.getAttribute('data-product-price-cents'),
        10
      );
      if (!Number.isFinite(unitPrice)) return;
      productPage.querySelectorAll('[data-submit-price]').forEach(function (element) {
        element.textContent = formatProductMoney(unitPrice * quantity);
      });
    }

    productPage.updateSubmitTotals = updateSubmitTotals;
    quantityInputs.forEach(function (input) {
      function syncQuantity() {
        var value = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = value;
        quantityInputs.forEach(function (otherInput) {
          if (otherInput !== input) otherInput.value = value;
        });
        updateSubmitTotals();
      }
      input.addEventListener('input', syncQuantity);
      input.addEventListener('change', syncQuantity);
    });
    updateSubmitTotals();

    var mobileBar = productPage.querySelector('[data-mobile-purchase-bar]');
    var primaryForm = productPage.querySelector('.product-form');
    if (!mobileBar || !primaryForm) return;

    var mobileViewport = window.matchMedia('(max-width: 767px)');
    var initialFormBounds = primaryForm.getBoundingClientRect();
    var initialVisibleHeight = Math.max(0, Math.min(window.innerHeight, initialFormBounds.bottom) - Math.max(0, initialFormBounds.top));
    var primaryFormVisible = initialVisibleHeight / Math.max(1, initialFormBounds.height) >= 0.28;
    var mobileBarVisible = false;
    var mobileBarHideTimer = 0;

    function showMobileBar() {
      window.clearTimeout(mobileBarHideTimer);
      mobileBar.classList.remove('is-exiting-down');
      mobileBar.setAttribute('aria-hidden', 'false');
      mobileBarVisible = true;

      window.requestAnimationFrame(function () {
        if (mobileBarVisible) mobileBar.classList.add('is-visible');
      });
    }

    function hideMobileBar() {
      window.clearTimeout(mobileBarHideTimer);
      mobileBarVisible = false;

      if (!mobileBar.classList.contains('is-visible')) {
        mobileBar.classList.remove('is-exiting-down');
        mobileBar.setAttribute('aria-hidden', 'true');
        return;
      }

      mobileBar.classList.add('is-exiting-down');
      mobileBar.classList.remove('is-visible');
      mobileBarHideTimer = window.setTimeout(function () {
        if (mobileBarVisible) return;
        mobileBar.classList.remove('is-exiting-down');
        mobileBar.setAttribute('aria-hidden', 'true');
      }, 280);
    }

    function updateMobileBar() {
      var shouldShow = mobileViewport.matches && !primaryFormVisible;
      if (shouldShow) showMobileBar();
      else hideMobileBar();
    }

    if ('IntersectionObserver' in window) {
      var purchaseObserver = new IntersectionObserver(function (entries) {
        primaryFormVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.28;
        updateMobileBar();
      }, { threshold: [0, 0.28, 0.6] });
      purchaseObserver.observe(primaryForm);
    } else {
      var checkPrimaryForm = function () {
        var bounds = primaryForm.getBoundingClientRect();
        primaryFormVisible = bounds.bottom > 0 && bounds.top < window.innerHeight;
        updateMobileBar();
      };
      window.addEventListener('scroll', checkPrimaryForm, { passive: true });
      window.addEventListener('resize', checkPrimaryForm, { passive: true });
      checkPrimaryForm();
    }

    if (mobileViewport.addEventListener) mobileViewport.addEventListener('change', updateMobileBar);
    else if (mobileViewport.addListener) mobileViewport.addListener(updateMobileBar);
    updateMobileBar();
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    var currentLabel = gallery.querySelector('[data-gallery-current]');
    var previous = gallery.querySelector('[data-gallery-previous]');
    var next = gallery.querySelector('[data-gallery-next]');
    var activeIndex = 0;
    var targetIndex = null;
    var scrollEndTimer = 0;
    if (!track || !slides.length) return;

    function normalizeIndex(index) {
      return (index + slides.length) % slides.length;
    }

    function updateGallery(index) {
      activeIndex = normalizeIndex(index);
      if (currentLabel) currentLabel.textContent = activeIndex + 1;
      thumbnails.forEach(function (thumbnail, thumbnailIndex) {
        if (thumbnailIndex === activeIndex) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });
    }

    function goToImage(index, behavior) {
      var normalized = normalizeIndex(index);
      var slide = slides[normalized];
      if (!slide) return;
      targetIndex = normalized;
      updateGallery(normalized);
      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
      if (thumbnails[normalized]) {
        thumbnails[normalized].scrollIntoView({ behavior: behavior || 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    gallery.productGallerySelectMedia = function (mediaId) {
      var index = slides.findIndex(function (slide) {
        return slide.getAttribute('data-media-id') === String(mediaId);
      });
      if (index >= 0) goToImage(index, 'smooth');
    };

    if (previous) previous.addEventListener('click', function () { goToImage(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { goToImage(activeIndex + 1); });
    thumbnails.forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function () { goToImage(index); });
    });

    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goToImage(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });

    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        var closestIndex = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        targetIndex = null;
        updateGallery(closestIndex);
      }, targetIndex === null ? 120 : 180);
    }, { passive: true });
  });

  document.querySelectorAll('[data-product-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var selected = select.options[select.selectedIndex];
      var price = selected && selected.getAttribute('data-price');
      var productPage = select.closest('[data-product-page]');
      if (!price || !productPage) return;
      productPage.querySelectorAll('[data-product-price]').forEach(function (element) {
        element.textContent = price;
      });
      var mediaId = selected && selected.getAttribute('data-media-id');
      var gallery = productPage.querySelector('[data-product-gallery]');
      productPage.querySelectorAll('[data-product-select]').forEach(function (otherSelect) {
        if (otherSelect !== select && otherSelect.value !== select.value) {
          otherSelect.value = select.value;
        }
      });
      if (productPage.updateSubmitTotals) productPage.updateSubmitTotals();
      if (mediaId && gallery && gallery.productGallerySelectMedia) {
        gallery.productGallerySelectMedia(mediaId);
      }
    });
  });

  document.querySelectorAll('[data-product-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var previous = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (!track) return;

    function move(direction) {
      var card = track.querySelector('.product-card');
      var distance = card ? card.getBoundingClientRect().width : track.clientWidth * 0.75;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    if (previous) previous.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
  });

  var newsletter = document.querySelector('[data-newsletter-popup]');
  if (newsletter) {
    var newsletterClosed = false;
    var newsletterRevealTimer = 0;
    try {
      newsletterClosed = Boolean(window.sessionStorage.getItem('readers-newsletter-closed'));
    } catch (error) {}

    function revealNewsletter() {
      if (newsletterClosed) return;
      if (cookieNotice && !cookieNotice.hidden) {
        newsletterRevealTimer = window.setTimeout(revealNewsletter, 2000);
        return;
      }
      newsletter.hidden = false;
      newsletter.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () {
        newsletter.classList.add('is-visible');
      });
    }

    if (!newsletterClosed) {
      var newsletterDelay = Math.max(0, parseInt(newsletter.getAttribute('data-newsletter-delay'), 10) || 0);
      newsletterRevealTimer = window.setTimeout(revealNewsletter, newsletterDelay);
    }

    var newsletterClose = newsletter.querySelector('[data-newsletter-close]');
    if (newsletterClose) {
      newsletterClose.addEventListener('click', function () {
        window.clearTimeout(newsletterRevealTimer);
        newsletterClosed = true;
        newsletter.classList.remove('is-visible');
        newsletter.setAttribute('aria-hidden', 'true');
        newsletter.hidden = true;
        try {
          window.sessionStorage.setItem('readers-newsletter-closed', 'true');
        } catch (error) {}
      });
    }
  }
})();
